<template>
  <div>
    <v-container fluid class="pa-0">
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" md="6" lg="4" sm="6" xs="12" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="font-weight-regular headline">
                Center level kit allocation
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" lg="8" sm="6" xs="12">
            <v-card-text
              class="pt-0 pr-1"
              :class="{
                'd-block py-3': $vuetify.breakpoint.xs,
                'd-flex align-center': $vuetify.breakpoint.smAndUp
              }"
            >
              <v-text-field
                :class="{
                  'mr-0': $vuetify.breakpoint.xs,
                  'mr-5': $vuetify.breakpoint.smAndUp
                }"
                v-model="search"
                hide-details="true"
                append-icon="mdi-magnify"
                class="ml-auto mb-2"
                label="Search"
                dense
                single-line
                style="max-width: 350px"
              />
              <router-link :to="{ name: 'uploadAllocationKitMapping' }">
                <v-btn
                  small
                  elevation="1"
                  :class="{ 'mt-2': $vuetify.breakpoint.xs }"
                  color="accent"
                >
                  <v-icon left>mdi-plus</v-icon>
                  Add
                </v-btn>
              </router-link>
            </v-card-text>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="2" sm="2" xs="12">
            <v-autocomplete
              name="centertype"
              :items="franchisees"
              v-model="selectedFranchisee"
              key="id"
              item-text="companyName"
              item-value="id"
            >
              <template v-slot:label> Center (Franchisee) Id </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="2" sm="2" xs="12">
            <v-autocomplete
              name="kittype"
              v-model="kit"
              :items="constantKit"
              key="id"
              @change="setkitType"
              return-object
              item-text="name"
            >
              <template v-slot:label> Kit Type </template>
            </v-autocomplete>
          </v-col>
          <v-col class="has-text-right" cols="12" md="2" sm="2" xs="12">
            <v-autocomplete
              v-model="selectedMappingObj.classID"
              :items="classList"
              item-text="name"
              item-value="id"
              key="id"
            >
              <template v-slot:label> Class Name </template>
            </v-autocomplete>
          </v-col>
          <v-col class="has-text-right" cols="12" md="2" sm="2" xs="12">
            <v-autocomplete
              key="id"
              :items="academicYears"
              v-model="academicYearID"
              item-text="academicYear"
              item-value="id"
            >
              <template v-slot:label> Academic Year </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="2" lg="2" sm="2" xs="12">
            <div class="d-flex justify-end caption">
              <v-btn
                v-if="$vuetify.breakpoint.smAndUp"
                small
                id="apply"
                color="success"
                elevation="1"
                type="submit"
                class="ml-2 mt-5"
                @click="getKitAllocationList"
              >
                <v-icon left size="18"> mdi-text-box-check-outline </v-icon>
                Apply
              </v-btn>
              <v-btn
                v-if="$vuetify.breakpoint.smAndUp"
                small
                elevation="1"
                type="reset"
                @click="resetAll()"
                class="ml-2 mt-5"
              >
                <v-icon left size="18"> mdi-restart</v-icon> Reset
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" lg="12" sm="12" xs="12">
            <v-data-table
              :search="search"
              item-key="id"
              :headers="headers"
              :items="allocationKitData"
            >
              <template v-slot:item.isActive="{ item }">
                <span class="has-text-success" v-if="item.isActive"
                  >Active</span
                >
                <span class="has-text-danger" v-else>In Active</span>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn
                  v-if="!item.isActive"
                  small
                  id="apply"
                  color="success"
                  elevation="1"
                  type="submit"
                  @click="updateStatus(item)"
                >
                  <v-icon left size="18"> mdi-text-box-check-outline </v-icon>
                  Active
                </v-btn>
                <v-btn
                  v-else
                  small
                  id="apply"
                  color="error"
                  elevation="1"
                  type="submit"
                  @click="updateStatus(item)"
                >
                  <v-icon left size="18"> mdi-delete </v-icon> DeActive
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import Utils from '@/utils'

export default {
  name: 'wowkitmapping',
  props: ['kitType'],
  data () {
    return {
      constantKit: _.filter(
        constants.KIT,
        (obj) => obj.isDisplayOnMapping === true
      ),
      data: [],
      columns: [],
      paginated: false,
      perPage: 10,
      checkedRows: [],
      total: 0,
      modelID: '',
      enableFilterModal: false,
      modelArr: [],
      franchisees: [],
      academicYears: [],
      academicYearID: '',
      selectedFranchisee: '',
      classList: [],
      allocationKitData: [],
      selected: 'All',
      kit: {},
      selectedMappingObj: {
        kitID: 0,
        classID: ''
      },
      loadingComponent: null,
      search: '',
      headers: [
        {
          text: 'Franchisee',
          value: 'franchisee.companyName',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Kit Set Name',
          value: 'kitSetMap.name',
          sortable: true,
          align: 'center'
        },
        { text: 'Status', value: 'isActive', sortable: true, align: 'center' },
        { text: 'Priority', value: 'priority', align: 'center' },
        { text: 'Action', value: 'action', align: 'center' }
      ],
      isPaginationApply: true,
      page: 1,
      totalPages: 0,
      totalItems: 0,
      pageSize: 10,
      pageSizes: [5, 10, 50, 100],
      isLoading: false,
      showRecord: null
    }
  },
  created: async function () {
    await this.onStart()
  },
  watch: {
    kitType: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.onStart()
      }
    }
  },
  methods: {
    onStart: async function () {
      this.kit = _.find(this.constantKit, (item) =>
        _.isEqual(item.route, this.kitType)
      )
      if (!_.isEmpty(this.kit)) {
        this.selectedMappingObj.kitID = ''
        this.selectedMappingObj.classID = ''
        await this.getKitType()
        await this.getAcademicYear()
        await this.getKitAllocationList()
        await this.getFranchisee()
        await this.getClasses()
      } else {
        return this.$buefy.dialog.alert({
          message: 'Select valid kit',
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    updateStatus: async function (item) {
      try {
        const response = await http.post(
          `${constants.API_URL}/api/kitSetMapping/update-status/${item.id}`
        )
        console.log('response 240 ', response)
        await this.getKitAllocationList()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching product id ', errorMessage)
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getClasses: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const studentclasses = await http.get(
          `${constants.API_URL}/api/students/class`
        )
        this.classList = studentclasses.data.rows

        this.classList.filter((item) => {
          item.category = item.category ? ' ( ' + item.category + ' )' : ''
          item.name = item.name + ' ' + item.category
        })
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching product id ', errorMessage)
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getAcademicYear: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        const data = response.data
        this.academicYears = data.rows

        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find((y) => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching Franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    getFranchisee: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/franchisee/active`
        )
        const data = response.data

        if (data.rows.length > 1) {
          this.franchisees = [{ id: '', companyName: 'Select All' }].concat(
            data.rows
          )
        } else {
          this.franchisees = data.rows
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching Franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    dateFormat: function (i) {
      let j = i % 10
      let k = i % 100
      if (j === 1 && k !== 11) {
        return i + 'st'
      }
      if (j === 2 && k !== 12) {
        return i + 'nd'
      }
      if (j === 3 && k !== 13) {
        return i + 'rd'
      }
      return i + 'th'
    },
    setkitType: function () {
      if (!_.isEmpty(this.kit)) {
        this.$router.push({
          name: 'kitAllocationListMapping',
          params: {
            kitType: this.kit.route,
            kitID: Number(this.selectedMappingObj.kitID)
          }
        })
      }
    },
    getKitType: async function () {
      try {
        this.classList = []
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(
          `${constants.API_URL}/api/kits?kitType=${this.kit.id}`
        )
        this.loadingComponent.close()
        if (response.data) {
          _.forEach(response.data.rows, (item) => {
            if (typeof item.studentClass !== 'undefined') {
              this.classList.push(item.studentClass)
            }
          })
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching product id ', errorMessage)
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    resetAll: function () {
      this.selectedFranchisee = ''
      this.selectedMappingObj.KitID = 0
      this.selectedMappingObj.classID = ''
      this.getKitAllocationList()
    },
    getKitAllocationList: async function () {
      try {
        this.allocationKitData = []
        this.loadingComponent = this.$buefy.loading.open()
        let payload = { kitType: this.kit.id }
        if (this.selectedFranchisee) {
          payload.franchiseeID = this.selectedFranchisee
        }
        if (this.selectedMappingObj.classID) {
          payload.classID = Number(this.selectedMappingObj.classID)
        }
        if (this.academicYearID) {
          payload.academicYear = this.academicYearID
        }
        console.log('ay ', this.academicYearID)

        const response = await http.get(
          `${constants.API_URL}/api/kitSetMapping/get-kitSet-franchisee-mapping`,
          { params: payload }
        )

        if (response.data.length > 0) {
          this.allocationKitData = response.data
          this.totalPages = response.data.totalPages
          this.totalItems = response.data.totalItems
          this.total = this.allocationKitData.length
        } else {
          this.allocationKitData = []
          this.total = 0
          this.paginated = false
        }
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }
}
</script>
